import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leistungsangebot',
  templateUrl: './leistungsangebot.component.html',
  styleUrls: ['./leistungsangebot.component.scss']
})
export class LeistungsangebotComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
